<template>
  <b-modal
    id="modalAdjustSaleAmounts"
    centered
    title="Adjust sale values"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="id" class="form-label">ID da Venda</label>
      <b-form-input
        id="id"
        v-model="id"
        placeholder="Digite o ID da venda"
        type="number"
        :state="!errorsForm.id"
      />
      <b-form-invalid-feedback v-if="errorsForm.id">{{ errorsForm.id }}</b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="amount" class="form-label">Valor</label>
      <b-form-input
        id="amount"
        v-model="amount"
        placeholder="Digite o valor ajustado"
        type="number"
        step="0.01"
        :state="!errorsForm.amount"
      />
      <b-form-invalid-feedback v-if="errorsForm.amount">{{ errorsForm.amount }}</b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="installments" class="form-label">Parcelas</label>
      <b-form-input
        id="installments"
        v-model="installments"
        placeholder="Digite o número de parcelas"
        type="number"
        :state="!errorsForm.installments"
      />
      <b-form-invalid-feedback v-if="errorsForm.installments">{{ errorsForm.installments }}</b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="primary" @click="submitData">Ajustar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import adjustSaleAmountsService from '@services/resources/adjustSaleAmounts'; 

const service = adjustSaleAmountsService.build();

export default {
  name: 'modalAdjustSaleAmounts',
  data() {
    return {
      id: '',
      amount: '',
      installments: '',
      errorsForm: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.id.toString().trim()) {
        this.errorsForm.id = 'O campo ID da venda é obrigatório.';
      }
      if (!this.amount.toString().trim() || isNaN(Number(this.amount))) {
        this.errorsForm.amount = 'O campo Valor é obrigatório e deve ser numérico.';
      }
      if (!this.installments.toString().trim() || isNaN(Number(this.installments))) {
        this.errorsForm.installments = 'O campo Parcelas é obrigatório e deve ser numérico.';
      }

      return Object.keys(this.errorsForm).length === 0;
    },

    async submitData() {
      if (!this.validateFields()) return;

      try {
        const payload = {
          id: Number(this.id),
          amount: Number(this.amount),
          installments: Number(this.installments),
        };

        await service.post('', payload);

        this.$bvToast.toast('Venda ajustada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalAdjustSaleAmounts');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar';

        if (error.response && error.response.data && error.response.data.errors) {
          message = Object.values(error.response.data.errors).flat().join('\n');
        } else if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },

    resetForm() {
      this.id = '';
      this.amount = '';
      this.installments = '';
      this.errorsForm = {};
    },
  },
};
</script>
